import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import '@mdi/font/css/materialdesignicons.css'
import ro from 'vuetify/es5/locale/ro'

Vue.use(Vuetify);

const opts = {
    lang: {
        locales: {ro},
        current: 'ro'
    }
}

export default new Vuetify(opts)
